module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_ccp-small-a66efe5e69235273d889b012da172d1d.png";